import { render, staticRenderFns } from "./staffAssessmentInfo.vue?vue&type=template&id=fff5fb6c&scoped=true&"
import script from "./staffAssessmentInfo.vue?vue&type=script&lang=js&"
export * from "./staffAssessmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./staffAssessmentInfo.vue?vue&type=style&index=0&id=fff5fb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff5fb6c",
  null
  
)

export default component.exports